export default "__VITE_ASSET__DcEsmkO___"